module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/220.b7d68279.png";